import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { HomeCardComponent } from './home-card.component';

@Component({
  selector: 'app-search-card',
  imports: [ButtonComponent, HomeCardComponent, RouterLink],
  template: `
    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
      @if (!session.authorize('NoVovHexOnly')) {
        <div [class]="hasDashboardAccess ? 'tw-basis-1/2' : 'tw-basis-full'">
          <app-home-card
            type="Large"
            theme="Dark"
            [padding]="false"
            [minHeight]="'450px'"
            classes="tw-h-[470px]"
          >
            <div class="tw-flex tw-justify-center tw-pb-8">
              <h4>Search claims</h4>
            </div>
            <div class="tw-flex tw-pt-8 tw-pb-8 tw-justify-center tw-h-[250px]">
              <img
                src="assets/images/home/search-claims.webp"
                alt="search claims"
                class="tw-max-h-[250px]"
              />
            </div>
            <div class="tw-flex tw-justify-start xl:tw-justify-center tw-p-10">
              <app-button
                label="Search"
                [routerLink]="['/view']"
                [queryParams]="{ tab: 'search' }"
              />
            </div>
          </app-home-card>
        </div>
      }
      @if (hasDashboardAccess) {
        <div class="tw-basis-1/2">
          <app-home-card
            type="Large"
            theme="Dark"
            [padding]="false"
            [minHeight]="'450px'"
            classes="tw-h-[470px]"
          >
            <div class="tw-flex tw-justify-center tw-pb-8">
              <h4>Dashboards</h4>
            </div>
            <div class="tw-flex tw-pt-8 tw-pb-8 tw-justify-center tw-h-[250px]">
              <img
                src="assets/images/home/dashboards.webp"
                alt="dashboards"
                class="tw-max-h-[250px]"
              />
            </div>
            <div class="tw-flex tw-justify-start xl:tw-justify-center tw-p-10">
              <app-button label="View" routerLink="/dashboards" />
            </div>
          </app-home-card>
        </div>
      }
    </div>
  `,
  styles: ``,
})
export class SearchCardComponent extends BaseComponent implements OnInit {
  hasDashboardAccess = false;

  ngOnInit() {
    this.hasDashboardAccess =
      !this.session.isSpecificClaimUser &&
      this.session.authorize('DashboardModule');
  }
}
